import React from 'react'

import { selectProjectById } from '../api/for-company/projects.api'
import { ForProjectRole } from '../components/Auth/ForProjectRole'
import { ToolbarActions } from '../components/Drawers/Toolbar'
import { AircraftInformationDrawer } from '../components/Projects/AircraftInformation/AircraftInformationDrawer'
import { ListSummaryRAS } from '../components/RAS/ListRASSummary'
import { ProjectRolePermissions } from '../domain/project-role.domain'
import { routes } from '../routes'
import { useAppSelector } from '../store'

import { Page } from './shared/Page'

export const RASSummaryPage: React.FC = () => {
    const { projectId } = routes.RASSummary.useParams()
    const project = useAppSelector(selectProjectById(projectId))

    if (!project) {
        return null
    }

    return (
        <ForProjectRole permission={ProjectRolePermissions.RASListSubparts} projectId={projectId}>
            <Page logo={project.auditorLogo}>
                <ListSummaryRAS projectId={projectId} />
            </Page>
            <ToolbarActions>
                <ForProjectRole
                    permission={ProjectRolePermissions.AircraftInformationView}
                    projectId={projectId}
                >
                    <AircraftInformationDrawer projectId={projectId} />
                </ForProjectRole>
            </ToolbarActions>
        </ForProjectRole>
    )
}
